"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames"));

require("../styles/_comment-button.scss");

function CommentButton(_ref) {
  var onClick = _ref.onClick,
      colour = _ref.colour,
      number = _ref.number,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      selected = _ref.selected;
  return _react["default"].createElement("button", {
    className: (0, _classnames["default"])("comment-button", {
      "comment-button--selected": selected
    }),
    style: {
      backgroundColor: colour.color,
      filter: colour.brightness,
      left: "".concat(xPercent, "%"),
      top: "".concat(yPercent, "%"),
      position: "absolute"
    },
    type: "button",
    onClick: onClick
  }, number);
}

var _default = (0, _react.memo)(CommentButton);

exports["default"] = _default;